import React from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';

const Layout: React.FC = () => {
  return (
    <div className="flex h-full min-h-0 flex-col bg-[#ecf1f5]">
      <AppHeader />
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
